import { defineMessage, useIntl } from 'react-intl';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

const title = defineMessage({
  id: 'slot.service.label',
  defaultMessage: 'Service & Hilfe',
});

export const useServiceLink = () => {
  const { formatMessage } = useIntl();
  const { locale } = useI18n();
  const { headerLinks } = useConfig();

  return {
    href: headerLinks[locale].serviceLink,
    label: formatMessage(title),
  };
};
